module.exports = __webpack_public_path__ + "static/media/AddNewUser.e2f74fe1.svg";